import { render } from "./IniFileCommonSetting.vue?vue&type=template&id=6c7397f0&scoped=true"
import script from "./IniFileCommonSetting.vue?vue&type=script&lang=js"
export * from "./IniFileCommonSetting.vue?vue&type=script&lang=js"

import "./IniFileCommonSetting.vue?vue&type=style&index=0&id=6c7397f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7397f0"]])

export default __exports__